import request from '@/libs/request'

// 耳标配置 列表
export function tagSettingListApi (data) {
  return request({
    url: `device/tagSetting`,
    method: 'get',
    params: data
  })
}

// 耳标配置 详情
export function tagSettingInfoApi (id) {
  return request({
    url: `device/tagSetting/` + id,
    method: 'get'
  })
}


// 耳标配置 编辑
export function tagSettingSaveApi (data) {
  return request({
    url: `device/tagSetting`,
    method: 'post',
    data: data
  })
}



